import type { CompanyWorkingHoursSlot } from "../types/company";

/**
 * How one day of `CompanyWorkingHours` reads. The stored shape is a slot
 * array per day, so the three states a provider can state are encoded in it:
 * an absent key is unknown, `[]` is closed, and `OPEN_24H_SLOT` alone is open
 * all day.
 *
 * This file is consumed by `@shaarp/ui`. `@shaarp/api` cannot import a runtime
 * value from this package, so it keeps a mirrored copy of `OPEN_24H_SLOT` in
 * `api/src/common/constants/working-hours.ts`, held to this one by
 * `api/src/common/mappers/mapScrapIoPlaceItemToCompany.spec.ts`.
 */
export const OPEN_24H_SLOT: CompanyWorkingHoursSlot = {
  open: "00:00",
  close: "24:00",
};

export type WorkingHoursDayStatus = "unknown" | "closed" | "open24h" | "slots";

/** Classifies the slots stored for one day (`undefined` when the key is absent). */
export function getWorkingHoursDayStatus(
  slots: readonly CompanyWorkingHoursSlot[] | null | undefined,
): WorkingHoursDayStatus {
  if (!slots) return "unknown";
  if (slots.length === 0) return "closed";
  if (
    slots.length === 1 &&
    slots[0].open === OPEN_24H_SLOT.open &&
    slots[0].close === OPEN_24H_SLOT.close
  ) {
    return "open24h";
  }
  return "slots";
}
